import { LinearProgress } from '@mui/material'
import * as React from 'react'
import { FixedOverlay } from '../templates/Wrappers'

export const Loading: React.FC = () => {

    return (
        <FixedOverlay >
            <div style={{ display: 'flex', justifyContent: 'center', width: '100%', height: 3, alignItems: 'center' }}>
                <LinearProgress style={{ width: '100%' }} />
            </div>
        </FixedOverlay>
    )
}
